import script from "./CrmListView.vue?vue&type=script&setup=true&lang=js"
export * from "./CrmListView.vue?vue&type=script&setup=true&lang=js"

import "./CrmListView.vue?vue&type=style&index=0&id=5c5d9997&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c5d9997"]])

export default __exports__